import React from "react"
import { Card, Grid } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as StudentLoanPayOffIcon } from "uikit/Icons/studentloanpayoff-goal.svg"
import { formatCurrency } from "uikit/utilities"
import { useStore } from "store"

const StudentLoanPayoff = ({
  id,
  monthly_amount,
  baseUrl,
  type,
  account_ids,
  ...account
}) => {
  const [accounts] = useStore("accounts")

  const totalLoanBeingOptimized = formatCurrency(
    Math.abs(
      account_ids
        .filter(accountId => !!accounts[accountId])
        .reduce(
          (balance, accountId) => balance + accounts[accountId].balance,
          0
        )
    )
  )
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <StudentLoanPayOffIcon />
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <span className="GenericCard__LinkTitle">
                        Student Loan Payoff
                      </span>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={1} style={{ paddingTop: "0px" }}>
                    <Grid.Column verticalAlign="bottom">
                      <p
                        className="GoalCard_SecondText"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {totalLoanBeingOptimized}
                      </p>
                      <p className="greyed-text">
                        Payoff {totalLoanBeingOptimized} in student loan debt
                        carried by {account_ids.length} student loan
                        {account_ids.length > 1 ? "s" : ""}.
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}

export default StudentLoanPayoff
